export const status_enum = {
    is_loading: 'is_loading',
    is_completed: 'is_completed',
    is_saving: 'is_saving',
};

export const ini_state = {
    status: status_enum,
    list_miengiam: [],
    list_miengiam_select: [],
    list_miengiam_adds: [],
    list_miengiam_dels: []
}
export const action_type = {
    SET_MIEN_GIAMS: "SET_MIEN_GIAMS",
    SELECT_MIENGIAM_BY_HOCSINH: 'SELECT_MIENGIAM_BY_HOCSINH',
    CHANGE_MIENGIAM: 'CHANGE_MIENGIAM',
    DELETE_MIENGIAM: 'DELETE_MIENGIAM',
}

export const reducer = (state, action) => {
    switch (action.type) {
        case action_type.SET_MIEN_GIAMS:
            return {
                ...state,
                list_miengiam: action.payload,
            };
        case action_type.SELECT_MIENGIAM_BY_HOCSINH:
            let _list_miengiam_adds = [];
            action.payload.forEach(element => {
                _list_miengiam_adds.push(element);
            });
            return {
                ...state,
                status: status_enum.is_completed,
                list_miengiam_adds: _list_miengiam_adds,
                list_miengiam_select: action.payload,
            };

        case action_type.CHANGE_MIENGIAM:
            let list_miengiam_adds = state.list_miengiam_adds;
            list_miengiam_adds = list_miengiam_adds.filter((val) => val.nhom_mien_giam !== action.payload.nhom_mien_giam);
            list_miengiam_adds.push(action.payload);
            return {
                ...state,
                list_miengiam_adds
            }
            case action_type.DELETE_MIENGIAM:
                let list_miengiam_dels = state.list_miengiam_adds;
                list_miengiam_dels = list_miengiam_dels.filter((val) => val.id !== action.payload.id);
                return {
                    ...state,
                    list_miengiam_adds: list_miengiam_dels
                }
          
        default:
            return state
    }
}